// Third-party Library
import React from "react";
import { Modal, Result } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const LoadingModal = () => {

    return (
        <Modal
            open={true}
            closable={false}
            footer={null}
            width={230}
        >
            <Result
                icon={<LoadingOutlined style={{ fontSize: 96 }} spin />}
                title="Loading..."
            />
        </Modal>
    )
}

export default React.memo(LoadingModal)